export enum NotificationTypeEnum {
  WORKFLOW_NOTIFICATION = 'WorkflowNotification',
  COMMENT_NOTIFICATION = 'CommentNotification',
  QUIZ_NOTIFICATION = 'QuizNotification',
  COURSE_NOTIFICATION = 'CourseNotification',
  UPDATED_COMMON_STEP_NOTIFICATION = 'UpdatedCommonStepNotification',
  DELETED_COMMON_STEP_NOTIFICATION = 'DeletedCommonStepNotification',
  ORG_INVITATION = 'OrgInvitation'
}

export enum NotificationActionEnum {
  WORKFLOW_NOTIFICATION = 'has an update on',
  COMMENT_NOTIFICATION = 'has a note on',
  QUIZ_NOTIFICATION = 'has an update on',
  COURSE_NOTIFICATION = 'has an update on'
}

export enum NotificationTitleEnum {
  UPDATED_COMMON_STEP_NOTIFICATION = 'updates available.',
  DELETED_COMMON_STEP_NOTIFICATION = 'is deleted.',
  UPDATED_COMMON_STEP_CONFIRM_NOTIFICATION = 'to apply changes on affected processes.'
}
